import { motion } from "framer-motion";
import { Play, Youtube } from "lucide-react";
import { VIDEO } from "@/data/content";

const VideoSection = () => {
  const openVideo = () => window.open(VIDEO.youtubeUrl, "_blank", "noopener,noreferrer");

  return (
    <section data-testid="video-section" className="bg-white pb-24 lg:pb-32">
      <div className="max-w-3xl mx-auto px-5 lg:px-8 text-center">
        <p className="text-[#1d3fd9] font-bold tracking-widest text-sm mb-3">NO YOUTUBE</p>
        <h2 className="text-3xl lg:text-4xl font-extrabold text-[#0f1733] tracking-tight mb-3">
          {VIDEO.title}
        </h2>
        <p className="text-slate-500 mb-10">{VIDEO.caption}</p>

        <motion.button
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          data-testid="video-card"
          onClick={openVideo}
          aria-label="Assistir vídeo no YouTube"
          className="group relative mx-auto block w-full aspect-video rounded-3xl overflow-hidden bg-[#0f1733] shadow-2xl"
        >
          <img
            src={VIDEO.thumb}
            alt={VIDEO.title}
            className="w-full h-full object-cover"
            onError={(e) => {
              e.currentTarget.src = `https://img.youtube.com/vi/${VIDEO.videoId}/hqdefault.jpg`;
            }}
          />
          <span className="absolute inset-0 bg-black/25 group-hover:bg-black/15 transition-colors" />
          <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center w-20 h-14 rounded-2xl bg-[#ff0000] shadow-xl transition-transform group-hover:scale-110">
            <Play className="w-8 h-8 text-white fill-white ml-1" />
          </span>
          <span className="absolute bottom-4 left-1/2 -translate-x-1/2 flex items-center gap-2 bg-black/55 backdrop-blur text-white font-semibold text-sm px-4 py-2 rounded-2xl whitespace-nowrap">
            Assista no <Youtube className="w-5 h-5 text-[#ff0000]" /> YouTube
          </span>
        </motion.button>

        <a
          href={VIDEO.youtubeUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="video-link"
          className="inline-flex items-center gap-2 mt-8 text-[#1d3fd9] font-semibold hover:underline break-all"
        >
          <Youtube className="w-5 h-5 text-[#ff0000]" /> {VIDEO.youtubeUrl}
        </a>
      </div>
    </section>
  );
};

export default VideoSection;
